import React, { useState } from 'react'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import { useHistory } from 'react-router-dom'
import withAppconfig from '../../AppContext'
import { Grid, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { useCookies } from 'react-cookie'
import { setReturnPathCookie } from '../../utils/returnpath'
import { getPosterUrl } from '../ViewUtils'
import { useTranslation } from 'react-i18next'
import { isContinuousProduct, periodLabel } from '../../utils/subscriptions'
import CardMembershipIcon from '@material-ui/icons/CardMembership'
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard'
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber'

// Shown in the image area of a product that has no image.
const PLACEHOLDER_ICONS = { membership: CardMembershipIcon, gift: CardGiftcardIcon, card: ConfirmationNumberIcon }

// The venue logo for the placeholder, picked as TopNavigation does: the navigation logo, else the default.
const venueLogoUrl = (logos) => {
  if (!Array.isArray(logos)) return null
  const logo = logos.find((l) => l.loc === 'navigation') || logos.find((l) => l.loc === 'default')
  return logo && logo.type === 'url' && logo.value ? logo.value : null
}

const centered = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }

const ProductCard = ({ product, personname, appconfig, collection, isAuthRequired, isAuth }) => {
  const history = useHistory()
  const { t } = useTranslation()
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['gobackurl'])
  const { poster, id, variations } = product
  const path = [appconfig.pathPrefix, 'shop', collection, id].join('/')

  // let _optimizedPoster = ''
  // if (poster && typeof poster === 'object') {
    
  // if (poster && poster.indexOf('.svg') > -1) {
  //   _optimizedPoster = poster
  // } else {
  //   _optimizedPoster = poster
  //     ? poster
  //         .split('/')
  //         .splice(0, poster.split('/').length - 1)
  //         .join('/') +
  //       '/600_' +
  //       poster.split('/').splice(-1)
  //     : ''
  // }
  let price = ''
  if (variations && variations.length > 0) {
    // Variations at different prices: the lowest, as 'alkaen 19,00 €'.
    const prices = variations.map((v) => Number(v.price)).filter((p) => !isNaN(p))
    const lowest = prices.length > 0 ? Math.min(...prices) : Number(variations[0].price)
    price = (lowest / 100).toFixed(2).replace('.', ',') + ' €'
    if (new Set(prices).size > 1) price = t('price_from') + ' ' + price
    // A continuous membership is priced per period ('19,00 € / kk'), like on its own page.
    const period = isContinuousProduct(product) ? periodLabel(product.validity, t) : ''
    if (period) price += ' / ' + period
  }

  const goToProduct = () => {
    if (isAuthRequired && !isAuth) {
      setReturnPathCookie(setCookie, path)
      history.push(appconfig.pathPrefix + '/login')
      return
    } else {
      history.push(path)
    }
  }

  const posterUrl = getPosterUrl(poster, 300)
  const PlaceholderIcon = PLACEHOLDER_ICONS[collection] || CardMembershipIcon
  const [logoFailed, setLogoFailed] = useState(false)
  const logoUrl = logoFailed ? null : venueLogoUrl(appconfig.logos)

  return (
    <Card style={{ marginTop: 20 }}>
      {/* The 16:9 image area is always there, so a product without an image is the same size as the rest. */}
      {posterUrl ? (
        <CardMedia image={posterUrl} style={{ paddingTop: '56.25%' }} />
      ) : (
        <div style={{ position: 'relative', paddingTop: '56.25%', backgroundColor: '#eceff1' }}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt=''
              onError={() => setLogoFailed(true)}
              style={{ ...centered, maxHeight: '35%', maxWidth: '50%', objectFit: 'contain' }}
            />
          ) : (
            <PlaceholderIcon style={{ ...centered, fontSize: 64, color: '#b0bec5' }} />
          )}
        </div>
      )}
      <CardContent onClick={goToProduct}>
        <Grid container direction='row' justifyContent='space-between' alignItems='center'>
          <Grid item xs={12}>
            <Typography variant='h6'>{product.displayName}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Button size='small' variant='contained' color='primary' disabled={isAuthRequired && !isAuth} onClick={goToProduct}>
              Osta
            </Button>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <Typography variant='subtitle1'>{price}</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions></CardActions>
    </Card>
  )
}

export default withAppconfig(ProductCard)
